(function () {
  function setup(desc) {
    if (desc.dataset.clampInit) return;
    desc.dataset.clampInit = 'true';
    desc.setAttribute('data-clamp', 'collapsed');

    requestAnimationFrame(function () {
      if (desc.scrollHeight - desc.clientHeight < 6) {
        desc.removeAttribute('data-clamp');
        return;
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-description-toggle';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function () {
        var expanded = desc.getAttribute('data-clamp') === 'expanded';
        desc.setAttribute('data-clamp', expanded ? 'collapsed' : 'expanded');
        btn.textContent = expanded ? 'Read more' : 'Read less';
        btn.setAttribute('aria-expanded', String(!expanded));
      });

      desc.insertAdjacentElement('afterend', btn);
    });
  }

  document.querySelectorAll('.product__description.rte.quick-add-hidden').forEach(setup);
})();
